module.exports = __webpack_public_path__ + "static/media/launch_beach_2.81e7bfa5.svg";